/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Bad_Pony_AssureInputs */

const fr_new_bad_pony_assure = /** @type {(inputs: New_Bad_Pony_AssureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue`)
};

/**

* @param {New_Bad_Pony_AssureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const new_bad_pony_assure = /** @type {((inputs?: New_Bad_Pony_AssureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Bad_Pony_AssureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_new_bad_pony_assure(inputs)
});